 import { useState,useEffect} from "react";
import Editor from "./Editor";
 
function App() {
  const [html, setHtml] = useState("");
  const [css, setCss] = useState("");
  const [js, setJs] = useState("");
  const [srcDoc,setSrcDoc] = useState("");
  useEffect(() => {
    const timeout = setTimeout(() => {
      setSrcDoc(`<html>
      <body>
      ${html}
      </body>
      <style>${css}</style>
      <script>${js}</script>
      </html>`)
    }, 250);
  
    return () => clearTimeout(timeout);
  }, [html, css, js])
  
   
  return (
    <div className="App">
   <div className="pane top-pane">

    <Editor language="xml" displayName="HTML" value={html} onChange={setHtml}/>
    <Editor language="css" displayName="CSS" value={css} onChange={setCss}/>
    <Editor language="javascript" displayName="JS" value={js} onChange={setJs} />
    

   </div>
   <div className="pane">
     <iframe 

       title="output"
       sandbox="allow-scripts"
       frameBorder="0"
       width="100%"
        srcDoc={srcDoc}
   
       height="100%"/> 
   </div>
    </div>
  );
}

export default App;
